import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const normalizeSectionId = (sectionId) => sectionId.replace(/^#/, '');

export function useGoToHomeSection() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(
    (sectionId) => {
      const id = normalizeSectionId(sectionId);

      if (pathname === '/') {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.history.replaceState(null, '', `#${id}`);
          return;
        }
      }

      navigate({ pathname: '/', hash: id });
    },
    [navigate, pathname],
  );
}
